import { QueryClient } from '@tanstack/react-query';
import { createApiClient } from '@shripos/ui';
import { useSession } from '../stores/session.js';

const base = import.meta.env.VITE_API_URL ?? '';
export const API_BASE = `${base}/api/admin/v1`;

export const api = createApiClient({
  baseUrl: API_BASE,
  onAuthLost: (err) => useSession.getState().signedOut(err?.code === 'SESSION_EXPIRED' ? 'idle' : 'expired'),
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: (count, err) => count < 2 && (err?.status ?? 500) >= 500,
      refetchOnWindowFocus: true,
    },
  },
});

/** Build a query string, skipping empty values. */
export function qs(params) {
  const s = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v !== undefined && v !== null && v !== '') s.set(k, v);
  const str = s.toString();
  return str ? `?${str}` : '';
}
